import React from 'react';

export default function SkeletonCuts() {
  return (
    <section className="section">
      <div className="container">
        <div className="grid grid--card">
          {[...Array(12)].map((_, index) => (
            <SkeletonCut key={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

function SkeletonCut() {
  return (
    <article className="cut-card cut-card--skeleton card grid__col-xs-12 grid__col-sm-6 grid__col-lg-3">
      <div className="card__media"></div>
      <h4 className="card__title u--text-align-center"></h4>
      <div className="cut-card__overlay">
        <div className="btn btn--primary"></div>
      </div>
    </article>
  );
}
